import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useCallback, useEffect } from 'react'
import { shallowEqual, useSelector } from 'react-redux'

import { RequestStatus } from 'clickNgo/configs/service/common'

import { getNewPartnerById } from '../api/getNewPartnerById'
import { getPartnerById } from '../api/getPartnerById'
import { resetPartnerData } from '../partnerSlice'
import { selectPartnerData } from '../selectors/selectPartnerData'

export const useGetPartnerData = (partnerId: string = '') => {
  const dispatch = useAppDispatch()
  const { data, status, message } = useSelector(selectPartnerData, shallowEqual)

  const fetchPartnerData = useCallback(
    (isForce?: boolean) => {
      const options = { cacheKey: partnerId, isForce }
      if (partnerId.startsWith('new-') || partnerId.startsWith('portal-')) {
        dispatch(getNewPartnerById({ partnerId, options }))
      } else {
        dispatch(getPartnerById({ partnerId, options }))
      }
    },
    [dispatch, partnerId]
  )

  useEffect(() => {
    const fetchedPartnerId = data?.partnerId
    const isNewPartnerId = partnerId !== fetchedPartnerId
    const isValidRetryStatus = status !== RequestStatus.PENDING

    if (partnerId === '') {
      dispatch(resetPartnerData)
    }

    if (partnerId && isValidRetryStatus && isNewPartnerId) {
      fetchPartnerData()
    }
  }, [data?.partnerId, dispatch, fetchPartnerData, partnerId, status])

  return { partnerData: data, status, message, fetchPartnerData }
}
